import React, { useState } from 'react';
import { COLORS, FONTS, cardStyle, primaryButtonStyle, handleInputFocus, handleInputBlur } from '../signup/signupStyles';
import { SEED_ANSWERS } from './opportunityData';

const VoteButton = ({ voted, onVote, count }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
    <button onClick={onVote} style={{
      width: '40px', height: '40px', borderRadius: '6px',
      border: voted ? `2px solid ${COLORS.salmon}` : `1.5px solid ${COLORS.border}`,
      backgroundColor: voted ? `${COLORS.salmon}10` : '#fff',
      cursor: voted ? 'default' : 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.2s'
    }}>
      <svg width="16" height="16" viewBox="0 0 24 24"
        fill={voted ? COLORS.salmon : 'none'}
        stroke={voted ? 'none' : COLORS.muted} strokeWidth={2}>
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    </button>
    <span style={{ fontSize: '12px', fontWeight: '600', color: voted ? COLORS.salmon : COLORS.text }}>
      {count}
    </span>
  </div>
);

export const OpportunityReflect = ({ question, condition, onDone }) => {
  const [phase, setPhase] = useState('answer'); // 'answer' | 'results'
  const [userAnswer, setUserAnswer] = useState('');
  const answers = SEED_ANSWERS[question.id] || [];
  const [votes, setVotes] = useState(
    answers.reduce((acc, a) => ({ ...acc, [a.id]: a.votes }), {})
  );
  const [votedIds, setVotedIds] = useState([]);

  const handleVote = (id) => {
    if (votedIds.includes(id)) return;
    setVotes(prev => ({ ...prev, [id]: prev[id] + 1 }));
    setVotedIds(prev => [...prev, id]);
  };

  if (phase === 'answer') {
    return (
      <div style={{
        minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
        alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
        fontFamily: FONTS.system
      }}>
        <div style={{ ...cardStyle, maxWidth: '540px' }}>
          <div style={{
            fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
            letterSpacing: '0.8px', color: COLORS.salmon, marginBottom: '16px',
            textAlign: 'center'
          }}>
            {condition} Community
          </div>

          <h2 style={{
            fontFamily: FONTS.serif, fontSize: 'clamp(20px, 4vw, 24px)',
            fontWeight: '700', color: COLORS.text, lineHeight: 1.4,
            margin: '0 0 24px', textAlign: 'center'
          }}>
            {question.question}
          </h2>

          <textarea
            value={userAnswer}
            onChange={(e) => setUserAnswer(e.target.value)}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            placeholder="Share your experience..."
            rows={4}
            style={{
              width: '100%', padding: '14px 16px', fontSize: '15px',
              border: `1.5px solid ${COLORS.border}`, borderRadius: '6px',
              outline: 'none', resize: 'vertical', boxSizing: 'border-box',
              fontFamily: FONTS.system, marginBottom: '20px',
              transition: 'border-color 0.2s, box-shadow 0.2s'
            }}
          />

          <button onClick={() => setPhase('results')}
            disabled={!userAnswer.trim()}
            style={{
              ...primaryButtonStyle, width: '100%', padding: '16px 24px',
              opacity: userAnswer.trim() ? 1 : 0.4,
              cursor: userAnswer.trim() ? 'pointer' : 'not-allowed'
            }}>
            See How Others Answered
          </button>
        </div>
      </div>
    );
  }

  // Results phase
  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        {/* User's answer */}
        <div style={{
          backgroundColor: `${COLORS.salmon}08`, border: `2px solid ${COLORS.salmon}`,
          borderRadius: '12px', padding: '24px', marginBottom: '24px'
        }}>
          <div style={{
            fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
            letterSpacing: '1px', color: COLORS.salmon, marginBottom: '10px'
          }}>Your Answer</div>
          <p style={{ fontSize: '15px', color: COLORS.text, lineHeight: 1.6, margin: 0 }}>
            {userAnswer}
          </p>
        </div>

        {/* Community answers */}
        <div style={{
          fontSize: '13px', fontWeight: '600', textTransform: 'uppercase',
          letterSpacing: '1px', color: COLORS.muted, marginBottom: '16px'
        }}>
          How others answered
        </div>

        {answers.map((item) => (
          <div key={item.id} style={{
            backgroundColor: '#fff', borderRadius: '12px', padding: '20px',
            marginBottom: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            display: 'flex', gap: '16px'
          }}>
            <VoteButton voted={votedIds.includes(item.id)}
              onVote={() => handleVote(item.id)} count={votes[item.id]} />
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '15px', color: COLORS.text, lineHeight: 1.6, margin: '0 0 8px' }}>
                {item.text}
              </p>
              <div style={{ fontSize: '13px', color: COLORS.muted }}>
                {item.author} · diagnosed {item.diagnosisTime}
              </div>
            </div>
          </div>
        ))}

        {/* Done CTA */}
        <div style={{
          marginTop: '32px', textAlign: 'center', padding: '28px',
          backgroundColor: '#fff', borderRadius: '12px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)'
        }}>
          <p style={{
            fontFamily: FONTS.serif, fontSize: '18px', fontWeight: '700',
            color: COLORS.text, margin: '0 0 8px'
          }}>
            Thanks for sharing.
          </p>
          <p style={{
            fontSize: '14px', color: COLORS.muted, margin: '0 0 20px', lineHeight: 1.5
          }}>
            We'll notify you about new questions and when your study eligibility is confirmed.
          </p>
          <button onClick={onDone} style={{
            ...primaryButtonStyle, padding: '14px 32px'
          }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#3a3a39'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = COLORS.text; }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};
